import { useCallback } from 'react';
import { sendMessengerMessage } from './api/api';
import { openMessenger } from '../../lib/messenger';

export const useSendChatMessage = () => {
    const sendChatMessage = useCallback(async (message: string) => {
        try {
            await sendMessengerMessage({
                messages: [{ text: message }],
            });

            /** Если сообщение отправлено успешно, то просто открываем чат (там уже будет отправленное сообщение) */
            openMessenger();
        } catch (_e) {
            /** Если сообщение не отправлено, то предзаполняем его за пользователя */
            openMessenger({
                pasteText: message,
                pasteForce: true,
            });
        }
    }, []);

    return sendChatMessage;
};
